module.exports = __webpack_public_path__ + "img/visa4.87d2ad56.png";